// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import {dispatchEvent} from 'fg-frontend/src/lib/dom';
import cookie from 'js-cookie';

class SimpleCollapse extends WebComponent {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.triggerActionOnLoad = this.triggerActionOnLoad.bind(this);
	}

	didMount() {
		const {
			simpleCollapseRestoreState,
			storeCookie,
		} = this.props;


		this.openedState = this.getState();

		if (storeCookie && simpleCollapseRestoreState) {
			this.restoreStateFromCookie();
		}

		this.bindEvents();

		// pokud je v location.hash id komponenty, provedeme akci pri loadu (deje se pri otevreni odkazu do noveho tabu}
		this.triggerActionOnLoad();
	}

	willUnMount() {
		const {
			collapseOnClickOutside,
		} = this.props;

		if (collapseOnClickOutside) {
			window.removeEventListener('click', this.handleClickOutside);
		}
	}

	triggerActionOnLoad() {
		if (location.hash != '' && this.element.href.indexOf(location.hash) != -1) {
			dispatchEvent(this.element, 'click');
		}
	}

	getState() {
		const {
			openedStateClass,
		} = this.props;
		let state = false;

		if ($(this.element).hasClass(openedStateClass)) {
			state = true;
		}

		return state;
	}

	bindEvents() {
		const {
			collapseOnClickOutside,
		} = this.props;

		if (collapseOnClickOutside) {
			window.addEventListener('click', this.handleClickOutside);
		}

		this.on('click', this.handleClick);
	}

	// osektreni kliknuti
	handleClick(e) {
		const {
			storeCookie,
			onAfterOpen,
			openedStateClass,
			togglingStateClass,
			allowOneActiveItem,
		} = this.props;
		const target = this.getTargetByType();
		const group = this.element.dataset.group;
		let allSc;

		e.preventDefault();
		e.stopPropagation();

		// zavreni jinych instanci SimpleCollapse
		if (allowOneActiveItem) {

			// pokud ma element nastavenou v datasetu skupinu, zavreme pouze elementy se stejnou skupinou, jinak zavreme vsechny
			if (group) {
				allSc = document.querySelectorAll(`[data-is='SimpleCollapse'][data-group='${group}']`);
			}
			else {
				allSc = document.querySelectorAll('[data-is="SimpleCollapse"]');
			}

			for (let i = 0; i < allSc.length; i++) {
				let sc = allSc[i];

				// vynechame sebe sama
				if (sc != this.element) {
					if (sc.classList.contains('active')) {
						// close opened sc item
						dispatchEvent(sc, 'click');
					}
				}
			}
		}

		this.element.classList.add(togglingStateClass);
		$(target).slideToggle({
			complete: (a, jumpedToEnd) => {
				this.element.classList.remove(togglingStateClass);
			}
		});

		if (this.openedState) {
			this.element.classList.remove(openedStateClass);
			this.openedState = false;
		} else {
			this.element.classList.add(openedStateClass);
			this.openedState = true;
		}

		this.setLinkText();

		if (storeCookie) {
			this.storeStateToCookie();
		}

		if (onAfterOpen && this.openedState) {
			onAfterOpen();
		}

		$('.js_bootstrap-slider-input').trigger('EDEESHOP_BOOTSTRAP_SLIDER_RELAYOUT');
	}

	// osetreni kliknuti mimo komponentu
	handleClickOutside(e) {
		let targetElement = this.element.getAttribute('href').split('?')[0] || this.element.getAttribute('data-href');

		if (targetElement == '#') {
			targetElement = `#${this.element.nextElementSibling.id}`;
		}

		const notSelf = !(e.target.closest(targetElement));

		if (this.openedState && notSelf) {
			dispatchEvent(this.element, 'click');
		}
	}

	// ulozeni stavu komponenty do cookie
	storeStateToCookie() {
		const {
			storeCookie,
			storeCookiePath,
		} = this.props;

		if (storeCookiePath) {
			const cookiePath = window.location.pathname;
			cookie.set(storeCookie + '_path', cookiePath, {expires: 1, path: '/'});
		}

		cookie.set(storeCookie, this.openedState, {expires: 1, path: '/'});
	}

	// nacteni stavu komponenty z cookie
	restoreStateFromCookie() {
		const {
			storeCookie,
		} = this.props;

		const storeCookieValue = cookie.get(storeCookie);

		if (storeCookieValue === 'true') {
			this.openedState = true;
			this.open();
			this.setLinkText();
		} else if (storeCookieValue === 'false') {
			this.openedState = false;
			this.close()
			this.setLinkText();
		}
	}

	// otevreni komponenty
	open() {
		const {
			openedStateClass,
		} = this.props;

		$(this.getTargetByType()).show();
		this.element.classList.add(openedStateClass);
	}

	// zavreni komponenty
	close() {
		const {
			openedStateClass,
		} = this.props;

		$(this.getTargetByType()).hide();
		this.element.classList.remove(openedStateClass);
	}

	// vrati cilovou komponentu v zavislosti na tom, zda targetujeme podle hodnoty href nebo data-href
	getTargetByType() {
		const {
			type,
			href,
		} = this.props;
		let result;

		if (type == 'href') {
			result = this.element.getAttribute('href').split('?')[0];

			if (result == '#') {
				result = `#${this.element.nextElementSibling.id}`;
			}
		} else if (type == 'data-href') {
			result = href;
		}

		return result;
	}

	// aktualizace textace komponenty, pokud existuje
	setLinkText() {
		const {
			simpleCollapseDefault,
			simpleCollapseActive,
		} = this.props;
		let linkText;

		if (this.openedState) {
			linkText = simpleCollapseActive;
		} else {
			linkText = simpleCollapseDefault;
		}
		if (linkText) {
			(this.element).innerHTML = linkText;
		}
	}
}

SimpleCollapse.defaultProps = {
	type: 'href',                       // href | data-href
	selector: '',
	offsetY: -10,
	simpleCollapseRestoreState: true,   // pokud je true, provede se nacteni stavu z cookie v JS, pokud false predpoklada se implementovana logika na serveru
	storeCookie: null,                  // pokud je nadefinovan nazev cookie, uklada do ni stav
	storeCookiePath: false,             // ukladani stavu do cookie vcetne path
	collapseOnClickOutside: false,      // collapse pri kliknuti mimo komponentu
	allowOneActiveItem: false,           // povoli aktivni pouze jednu polozku na strance, tj. ostatni vzdy pred otevrenim nove skryje
	simpleCollapseDefault: null,        // vychozi textace komponenty
	simpleCollapseActive: null,         // textace komponenty pri otevrenem stavu
	openedStateClass: 'active',           // trida identifikujici otevreny stav
	togglingStateClass: 'active-animating',           // trida identifikujici animaci pri otevirani/zavirani
	onAfterOpen: () => {
		dispatchEvent(window, 'resize');
	},
}

export default SimpleCollapse;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/SimpleCollapse.js